var map = {
	"./ar.json": 69991,
	"./cn.json": 79237,
	"./de.json": 35511,
	"./es.json": 80908,
	"./fr.json": 19996,
	"./id.json": 69981,
	"./ir.json": 56572,
	"./it.json": 96166,
	"./jp.json": 62312,
	"./pt.json": 20769,
	"./ru.json": 96515,
	"./tr.json": 81990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22238;